module.exports = __webpack_public_path__ + "static/media/logo-whatsapp-black.64517b8c.svg";